
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { SupplierTable } from "./SupplierTable";
import { StatsCards } from "./StatsCards";
import { Supplier } from "./types";
import { Button } from "@/components/ui/button";
import { PlusCircle } from "lucide-react";
import { AddSupplierDialog } from "./dialogs/AddSupplierDialog";

export const SupplierDashboard = () => {
  const [suppliers, setSuppliers] = useState<Supplier[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isAddDialogOpen, setIsAddDialogOpen] = useState(false);

  const fetchSuppliers = async () => {
    try {
      const { data, error } = await supabase
        .from("suppliers")
        .select(`
          *,
          supplier_ratings (*),
          supplier_orders (
            id,
            order_number,
            total_amount,
            status,
            expected_delivery_date,
            created_at
          )
        `);

      if (error) throw error;
      setSuppliers(data as Supplier[]);
    } catch (error) {
      console.error("Error fetching suppliers:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchSuppliers();
  }, []);

  if (isLoading) {
    return <div>Chargement...</div>;
  }

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold">Fournisseurs</h1>
        <Button onClick={() => setIsAddDialogOpen(true)}>
          <PlusCircle className="w-4 h-4 mr-2" />
          Ajouter un fournisseur
        </Button>
      </div>
      <StatsCards suppliers={suppliers} />
      <SupplierTable suppliers={suppliers} refetch={fetchSuppliers} />
      <AddSupplierDialog
        open={isAddDialogOpen}
        onOpenChange={setIsAddDialogOpen}
        onSuccess={fetchSuppliers}
      />
    </div>
  );
};
